import * as yup from 'yup';
import { ClientInfoCreateModel, ClientInfoUpdateModel } from './clitent-model';

export const clientCreateSchema: yup.ObjectSchema<ClientInfoCreateModel> = yup.object({
  first_name: yup.string().trim().required('first name required!'),
  last_name: yup.string().trim().required('last name required!'),
  phone: yup.string().required('phone required!'),
  email: yup.string().email('invalid email!').required('email required!'),
  role_id: yup.string().trim().required('role required!'),
  position_id: yup.string().trim().required('position required!'),
  province_id: yup.string().optional(),
  ministry_id: yup.string().optional(),
  department_id: yup
    .string()
    .optional()
    .test('at-least-one', 'ກະລຸນາເລືອກ ກະຊວງ, ແຂວງ ຫຼື ກົມ ຢ່າງໜ້ອຍ 1 ອັນ!', function (value) {
      return !!(value || this.parent.province_id || this.parent.ministry_id);
    }),
  description: yup.string().optional(),
  status: yup.boolean().optional(),
  show_accept_button: yup.boolean().optional(),
  user_position_id: yup.string().optional(),
});

export const clientUpdateSchema: yup.ObjectSchema<ClientInfoUpdateModel> = yup.object({
  id: yup.string().optional(),
  first_name: yup.string().trim().required('first name required!'),
  last_name: yup.string().trim().required('last name required!'),
  phone: yup.string().required('phone required!'),
  email: yup.string().email('invalid email!').required('email required!'),
  role_id: yup.string().trim().required('role required!'),
  position_id: yup.string().trim().required('position required!'),
  province_id: yup.string().optional(),
  ministry_id: yup.string().optional(),
  department_id: yup
    .string()
    .optional()
    .test('at-least-one', 'ກະລຸນາເລືອກ ກະຊວງ, ແຂວງ ຫຼື ກົມ ຢ່າງໜ້ອຍ 1 ອັນ!', function (value) {
      return !!(value || this.parent.province_id || this.parent.ministry_id);
    }),
  description: yup.string().optional(),
  status: yup.boolean().optional(),
  show_accept_button: yup.boolean().optional(),
  user_position_id: yup.string().optional(),
});
